<template>
  <div>
    <!-- faq search section -->
    <!--/ faq search section -->
    <b-card class="shadow-none py-1 faq-contact-card">
      <h2><center>Bize Ulaşın</center></h2><hr></b-card>
    <!-- frequently asked questions tabs pills -->
    <section id="faq-tabs">
      <b-tabs
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >

        <!-- payment tab -->

        <!--/ payment tab -->

        <!-- sitting lady image -->
        <template #tabs-end>
          <b-img
            fluid
            :src="require('@/assets/images/illustration/faq-illustrations.svg')"
            class="d-none d-md-block mt-auto"
          />
        </template>
        <!--/ sitting lady image -->
      </b-tabs>
    </section>
    <!--/ frequently asked questions tabs pills -->

    <!-- contact us -->
    <section class="faq-contact">
      <b-row class="mt-5 pt-75 text-center">
        <b-col cols="12" />
        <b-col sm="6">
          <b-card>
            <b-avatar
              size="42"
              rounded
              variant="success"
              class="mb-2"
            >
              <feather-icon
                icon="PhoneCallIcon"
                size="25"
              />
            </b-avatar><br>
            <span class="text-body">7/24 Destek Hattı</span><hr>
            <h4>
              <a href="tel:+903123956828">+90 (312) 395 68 28
              </a></h4>
          </b-card>
        </b-col>
        <b-col sm="6">
          <b-card>
            <b-avatar
              size="42"
              rounded
              variant="success"
              class="mb-2"
            >
              <feather-icon
                icon="MailIcon"
                size="25"
              />
            </b-avatar><br>
            <span class="text-body">E-posta Adresimiz</span><hr>

            <h4>
              <a href="mailto:info@winergytech.com">info@winergytech.com</a></h4>
          </b-card>
        </b-col>
      </b-row>
      <b-col sm="14">
        <b-card>
          <div class="d-flex justify-content-center">
            <b-avatar
              size="42"
              rounded
              variant="success"
              class="mb-2"
            >
              <feather-icon
                icon="NavigationIcon"
                size="25"
              />
            </b-avatar><br>
            <span class="text-body"><center>Adres</center></span><hr>
            <h5>
              <center>Serhat, İvedik OSB Başkanlığı AnkaraTeknopark<br> 06378 İvedik Osb/Yenimahalle/Ankara</center>
            </h5>
          </div>
        </b-card>
      </b-col>
    </section>
    <!--/ contact us -->
  </div>
</template>

<script>
import {
  BCard, BImg, BRow, BCol, BAvatar,
} from 'bootstrap-vue'

export default {
  components: {

    BCard,
    BRow,
    BCol,
    BAvatar,
    BImg,
  },
  data() {
    return {
      faqSearchQuery: '',
      faqData: {},
    }
  },
  watch: {
    faqSearchQuery: {
      immediate: true,
      handler() {
        this.fetchData()
      },
    },
  },
  methods: {
    fetchData() {
      this.$http.get('/faq/data', { params: { q: this.faqSearchQuery } }).then(res => { this.faqData = res.data })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
